import "./icons.scss";

export function CommitteeMeeting() {
	return (
		<div className="event-type-icon committee-meeting">
			
		</div>
	);
}

export function Plenary() {
	return (
		<div className="event-type-icon plenary">
			
		</div>
	);
}

export function MediaBriefing() {
	return (
		<div className="event-type-icon media-briefing">
			
		</div>
	);
}


export function BillIntroduced() {
	return (
		<div className="event-type-icon bill-introduced">
			<svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd" d="M7.74669 6.12929C7.387 5.53888 6.73895 5.14705 6 5.14705V3.81372C7.22319 3.81372 8.29376 4.46453 8.88536 5.43559L7.74669 6.12929Z" fill="white"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M7.74669 6.12929C7.387 5.53888 6.73895 5.14705 6 5.14705V3.81372C7.22319 3.81372 8.29376 4.46453 8.88536 5.43559L7.74669 6.12929Z" fill="white"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M4.25526 6.12929C4.61495 5.53888 5.263 5.14705 6.00195 5.14705V3.81372C4.77876 3.81372 3.70819 4.46453 3.1166 5.43559L4.25526 6.12929Z" fill="white"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M4.25526 6.12929C4.61495 5.53888 5.263 5.14705 6.00195 5.14705V3.81372C4.77876 3.81372 3.70819 4.46453 3.1166 5.43559L4.25526 6.12929Z" fill="white"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M10.2489 4.54113C9.37531 3.10723 7.79888 2.15218 6 2.15218V0.818848C8.28312 0.818848 10.2821 2.03289 11.3875 3.84743L10.2489 4.54113Z" fill="white"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M10.2489 4.54113C9.37531 3.10723 7.79888 2.15218 6 2.15218V0.818848C8.28312 0.818848 10.2821 2.03289 11.3875 3.84743L10.2489 4.54113Z" fill="white"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M1.75307 4.54113C2.62664 3.10723 4.20307 2.15218 6.00195 2.15218V0.818848C3.71883 0.818848 1.71987 2.03289 0.614404 3.84743L1.75307 4.54113Z" fill="white"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M1.75307 4.54113C2.62664 3.10723 4.20307 2.15218 6.00195 2.15218V0.818848C3.71883 0.818848 1.71987 2.03289 0.614404 3.84743L1.75307 4.54113Z" fill="white"/>
				<path d="M7.0612 7.9742C7.0612 8.55957 6.58667 9.0341 6.0013 9.0341C5.41594 9.0341 4.94141 8.55957 4.94141 7.9742C4.94141 7.38884 5.41594 6.91431 6.0013 6.91431C6.58667 6.91431 7.0612 7.38884 7.0612 7.9742Z" fill="white"/>
			</svg>
		</div>
	);
}

export function BillUpdated() {
	return (
		<div className="event-type-icon bill-updated">
			<svg viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd" d="M4.82422 9.1696C6.31424 9.1696 7.52214 7.9617 7.52214 6.47168L8.85547 6.47168C8.85547 8.69808 7.05062 10.5029 4.82422 10.5029C2.59782 10.5029 0.792969 8.69808 0.792969 6.47168C0.792969 4.24528 2.59782 2.44043 4.82422 2.44043L6.99563 2.44043L6.99563 3.77376L4.82422 3.77376C3.3342 3.77376 2.1263 4.98166 2.1263 6.47168C2.1263 7.9617 3.3342 9.1696 4.82422 9.1696Z" fill="white"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M6.61107 3.10732L5.01129 4.70709L5.9541 5.6499L8.49669 3.10732L5.9541 0.564732L5.01129 1.50754L6.61107 3.10732Z" fill="white"/>
			</svg>
		</div>
	);
}

export function BillPassed() {
	return (
		<div className="event-type-icon bill-passed">
			<svg viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd" d="M7.02409 4.66668L0.357422 4.66668L0.357422 3.33334L7.02409 3.33334L5.15742 0.844455L6.22409 0.0444553L9.19075 4.00001L6.22409 7.95557L5.15742 7.15557L7.02409 4.66668Z" fill="white"/>
			</svg>
		</div>
	);
}

export function BillSigned() {
	return (
		<div className="event-type-icon bill-signed">
			<svg viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd" d="M5.51792 0.478414L1.91797 4.07837L2.99077 5.15117L6.59053 1.55141L7.58101 2.54188L3.98124 6.14164L5.04947 7.20987L8.64942 3.60991L5.51792 0.478414Z" fill="white"/>
				<path d="M0.563328 8.57285L4.00465 7.70154L1.43463 5.13153L0.563328 8.57285Z" fill="white"/>
			</svg>

		</div>
	);
}

export function BillEnacted() {
	return (
		<div className="event-type-icon bill-enacted">
			<svg viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M4.99957 0.95752L6.13169 4.44183H9.7953L6.83137 6.59524L7.96349 10.0796L4.99957 7.92613L2.03564 10.0796L3.16776 6.59524L0.20383 4.44183H3.86745L4.99957 0.95752Z" fill="white" />
			</svg>
		</div>
	);
}

export function BillActCommenced() {
	return (
		<div className="event-type-icon bill-act-commenced">
			<svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1.57129 3.00007L3.857 5.28578L8.42843 0.714355" stroke="white" strokeWidth="2"/>
			</svg>
		</div>
	);
}



export function IconZoomIn() {
	return (
		<div className="circle-icon zoom-in">
			<div>+</div>
		</div>
	);
}

export function IconZoomOut() {
	return (
		<div className="circle-icon zoom-out">
			<div>-</div>
		</div>
	);
}

export function IconFullscreen() {
	return (
		<div className="circle-icon fullscreen">
			<div>
				<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M3.125 0.875C3.45703 0.875 3.75 1.16797 3.75 1.5C3.75 1.85156 3.45703 2.125 3.125 2.125H1.875V3.375C1.875 3.72656 1.58203 4 1.25 4C0.898438 4 0.625 3.72656 0.625 3.375V1.5C0.625 1.16797 0.898438 0.875 1.25 0.875H3.125ZM8.75 0.875C9.08203 0.875 9.375 1.16797 9.375 1.5V3.375C9.375 3.72656 9.08203 4 8.75 4C8.39844 4 8.125 3.72656 8.125 3.375V2.125H6.875C6.52344 2.125 6.25 1.85156 6.25 1.5C6.25 1.16797 6.52344 0.875 6.875 0.875H8.75ZM3.125 8.375C3.45703 8.375 3.75 8.66797 3.75 9C3.75 9.35156 3.45703 9.625 3.125 9.625H1.25C0.898438 9.625 0.625 9.35156 0.625 9V7.125C0.625 6.79297 0.898438 6.5 1.25 6.5C1.58203 6.5 1.875 6.79297 1.875 7.125V8.375H3.125ZM8.75 6.5C9.08203 6.5 9.375 6.79297 9.375 7.125V9C9.375 9.35156 9.08203 9.625 8.75 9.625H6.875C6.52344 9.625 6.25 9.35156 6.25 9C6.25 8.66797 6.52344 8.375 6.875 8.375H8.125V7.125C8.125 6.79297 8.39844 6.5 8.75 6.5Z" fill="#575757"/>
				</svg>
			</div>
		</div>
	);
}

export function IconReset() {
	return (
		<div className="circle-icon reset">
			<div>
				<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M9.375 5.25C9.375 7.67188 7.40234 9.625 5 9.625C4.04297 9.625 3.125 9.33203 2.36328 8.76562C2.08984 8.55078 2.03125 8.16016 2.24609 7.88672C2.46094 7.61328 2.85156 7.55469 3.125 7.75C3.67188 8.16016 4.31641 8.375 5 8.375C6.71875 8.375 8.125 6.98828 8.125 5.25C8.125 3.53125 6.71875 2.14453 5 2.14453C4.25781 2.14453 3.57422 2.39844 3.00781 2.84766L3.90625 3.72656C4.23828 4.05859 3.98438 4.64453 3.51562 4.64453H0.683594C0.46875 4.64453 0.3125 4.46875 0.3125 4.25391V1.42188C0.3125 0.933594 0.878906 0.699219 1.21094 1.03125L2.12891 1.96875C2.91016 1.28516 3.92578 0.894531 5 0.894531C7.40234 0.894531 9.375 2.84766 9.375 5.25Z" fill="#575757"/>
				</svg>
			</div>
		</div>
	);
}

export function IconMaximise() {
	return (
		<div className="circle-icon maximise">
			<div>
				<svg width="10" height="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
					<path d="M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32z"/>
				</svg>
			</div>
		</div>
	);
}